const getApiBaseUrl = (): string => {
  if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
  return `http://${window.location.hostname}:8765/api`;
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
    getPayloadData: (parserConfigId: number) =>
        `${API_BASE_URL}/PayloadData/GetPayloadData?id=${parserConfigId}`,

    parsePayloadWithValue:
        `${API_BASE_URL}/PayloadData/PayloadDataParseWithValue`,

    parserConfigReport:
        `${API_BASE_URL}/ParserConfig/ParserConfigReport`,

    parsePayload:
        `${API_BASE_URL}/PayloadData/PayloadDataParse`,

    extractJsonSchema:
        `${API_BASE_URL}/PayloadData/ExtractJsonSchema`,

    extractJsonSchemaWithValue:
        `${API_BASE_URL}/PayloadData/ExtractJsonSchemaWithValue`,

    createPayloadData:
        `${API_BASE_URL}/PayloadData/CreatePayloadData`,

    createKeyValueTable:
        `${API_BASE_URL}/KeyValueTable/Create`,

    updateKeyValueTable:
        `${API_BASE_URL}/KeyValueTable/Update`,

    updatePayloadData:
        `${API_BASE_URL}/PayloadData/UpdatePayloadData`,

    base64DataParse: (data?: string) =>
        `${API_BASE_URL}/Base64Data/Base64DataParse?base64=${encodeURIComponent(data ?? '')}`,

    rawDataConvert:
        `${API_BASE_URL}/RawData/Convert`,

    getDataTypeList:
        `${API_BASE_URL}/DataType/GetDataTypeList`,

    getParseDataTypeList:
        `${API_BASE_URL}/ParseDataType/GetParseDataTypeList`,

    parseToConvert:
        `${API_BASE_URL}/DataParse/ParseToConvert`,

    getParserConfig: (id: string) =>
        `${API_BASE_URL}/ParserConfig/GetParserConfig?id=${id}`,

    getParserConfigPaginate:
        `${API_BASE_URL}/ParserConfig/GetPaginate`,

    getParserConfigList:
        `${API_BASE_URL}/ParserConfig/GetParserConfigList`,

    getConnectionTypeList:
        `${API_BASE_URL}/ConnectionType/GetConnectionTypeList`,

    createParserConfig:
        `${API_BASE_URL}/ParserConfig/Create`,

    updateParserConfig:
        `${API_BASE_URL}/ParserConfig/Update`,

    getDevicePaginate:
        `${API_BASE_URL}/Device/GetPaginate`,

    createDevice:
        `${API_BASE_URL}/Device/Create`,

    updateDevice:
        `${API_BASE_URL}/Device/Update`,

    deleteDevice: (id: number) =>
        `${API_BASE_URL}/Device/Delete?id=${id}`,

    getDeviceTypeList:
        `${API_BASE_URL}/DeviceType/GetDeviceTypeList`,

    getPayloadTypeList:
        `${API_BASE_URL}/PayloadType/GetPayloadTypeList`,

    getDeviceList:
        `${API_BASE_URL}/Device/GetSensorList`,

    getDashboardByName: (name: string) =>
        `${API_BASE_URL}/Dashboard/GetByName?name=${encodeURIComponent(name)}`,

    createDashboard:
        `${API_BASE_URL}/Dashboard/Create`,

    updateDashboard:
        `${API_BASE_URL}/Dashboard/Update`,

    getDeviceKeys: (deviceId: number) =>
        `${API_BASE_URL}/Dashboard/DeviceKeys?deviceId=${deviceId}`,

    getKeyValueTablesRaw: (parserConfigId: number) =>
        `${API_BASE_URL}/KeyValueTable/GetKeyValueTablesRawByParserConfig?id=${parserConfigId}`,

    getGroupTablesByKeyValueIds: (ids: number[]) =>
        `${API_BASE_URL}/GroupTable/GetListByKeyValueTableIds?ids=${ids.join(',')}`,

    getChartData: (deviceId: number, keyIds: number[], from: string, to: string) =>
        `${API_BASE_URL}/Dashboard/ChartData?deviceId=${deviceId}&keyIds=${keyIds.join(',')}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,

    // User
    getProfile: `${API_BASE_URL}/User/GetProfile`,
    updateProfile: `${API_BASE_URL}/User/UpdateProfile`,
    getUserList: `${API_BASE_URL}/User/GetList`,
    getUserEntity: (id: number) => `${API_BASE_URL}/User/GetEntity?id=${id}`,
    createUser: `${API_BASE_URL}/User/Create`,
    updateUser: `${API_BASE_URL}/User/Update`,
    deleteUser: (id: number) => `${API_BASE_URL}/User/Delete?id=${id}`,
    resendInvitation: (userId: number) => `${API_BASE_URL}/User/ResendInvitation?userId=${userId}`,

    // Role
    getRoleList: `${API_BASE_URL}/Role/GetList`,
    getRoleEntity: (id: number) => `${API_BASE_URL}/Role/GetEntity?id=${id}`,
    createRole: `${API_BASE_URL}/Role/Create`,
    updateRole: `${API_BASE_URL}/Role/Update`,
    deleteRole: (id: number) => `${API_BASE_URL}/Role/Delete?id=${id}`,
    assignPermissions: `${API_BASE_URL}/Role/AssignPermissions`,

    // Permission
    getPermissionList: `${API_BASE_URL}/Permission/GetList`,

    // Company
    getCompanyList: `${API_BASE_URL}/Company/GetList`,
    createCompany: `${API_BASE_URL}/Company/Create`,
    updateCompany: `${API_BASE_URL}/Company/Update`,
    deleteCompany: (id: number) => `${API_BASE_URL}/Company/Delete?id=${id}`,

    getDeviceGroupListForForm: `${API_BASE_URL}/Device/GetGroupList`,
    getMyDeviceGroupListForForm: `${API_BASE_URL}/Device/GetMyGroups`,

    // DeviceGroup
    getDeviceGroupList: `${API_BASE_URL}/DeviceGroup/GetList`,
    getDeviceGroupEntity: (id: number) => `${API_BASE_URL}/DeviceGroup/GetEntity?id=${id}`,
    createDeviceGroup: `${API_BASE_URL}/DeviceGroup/Create`,
    updateDeviceGroup: `${API_BASE_URL}/DeviceGroup/Update`,
    deleteDeviceGroup: (id: number) => `${API_BASE_URL}/DeviceGroup/Delete?id=${id}`,
    assignUsersDeviceGroup: `${API_BASE_URL}/DeviceGroup/AssignUsers`,

    // Department
    getDepartmentList: (companyId?: number) =>
        companyId ? `${API_BASE_URL}/Department/GetList?companyId=${companyId}` : `${API_BASE_URL}/Department/GetList`,
    createDepartment: `${API_BASE_URL}/Department/Create`,
    updateDepartment: `${API_BASE_URL}/Department/Update`,
    assignCompanies: `${API_BASE_URL}/Department/AssignCompanies`,
    deleteDepartment: (id: number) => `${API_BASE_URL}/Department/Delete?id=${id}`,

    // Auth - Password
    checkTokenValid: (token: string) => `${API_BASE_URL}/Auth/token-valid/${encodeURIComponent(token)}`,
    setPassword: `${API_BASE_URL}/Auth/set-password`,
    sendPasswordReset: `${API_BASE_URL}/Auth/send-password-reset`,
};
